// ===== File: Services/AuthenticationService/ForgotPasswordApi.ts =====
import axios from "axios";
import { getClientConfig } from "../../config/clientConfig";

interface ImportMetaEnv {
  VITE_API_BASE_URL: string;
}

interface ImportMeta {
  env: ImportMetaEnv;
}
const clientConfig = getClientConfig();
const API_BASE_URL = clientConfig.backend_url // Example: http://localhost:5000/api

export const ResetApi = async (email: string) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/Account/forgotpassword/${email}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};


export const TwoFactorApi = async (userId: any, token: any) => {
    console.log("TwoFactorApi called with:", { userId, token });
  try {
    const response = await axios.post(
      `${API_BASE_URL}/Account/twofactorauthentication`,
      { userId, token } 
    );
    console.log("TwoFactorApi response:", response);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
